import { LoadsLifeAreas } from "@/types/lifeArea";

type LifeAreaOverlapOptions = {
    limit?: number;
    quizType?: string | null;
};

const LOW_PRIORITY_LIFE_AREA_CODE_NAMES = [
    "managing_stress",
    "work_life_balance",
    "well_being",
];

const LOW_PRIORITY_LIFE_AREA_CUTOFF = 4;

export function calculateLifeAreaOverlap(
    lifeAreasA: LoadsLifeAreas["life_areas"],
    lifeAreasB: LoadsLifeAreas["life_areas"],
    options?: LifeAreaOverlapOptions,
) {
    let overlap = lifeAreasA
        .filter((areaA) =>
            lifeAreasB.find(
                (areaB) =>
                    areaA.id === areaB.id && areaA.score > 0 && areaB.score > 0,
            ),
        )
        .sort((a, b) => {
            if (options?.quizType === "career") {
                if (a.code_name === "career_growth") {
                    return -1;
                }
                if (b.code_name === "career_growth") {
                    return 1;
                }
            }
            return b.score - a.score;
        });

    if (
        overlap.filter((area) => area.score === 2).length >
        LOW_PRIORITY_LIFE_AREA_CUTOFF
    ) {
        overlap = overlap.filter(
            (area) =>
                !LOW_PRIORITY_LIFE_AREA_CODE_NAMES.includes(area.code_name),
        );
    }

    overlap = overlap.slice(0, options?.limit);
    if (
        options?.quizType === "career" &&
        overlap.length === 1 &&
        overlap[0].code_name === "career_growth"
    ) {
        return [];
    }
    return overlap;
}
